import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'
import {ChangePasswordForm} from '../../components/ChangePasswordForm/ChangePasswordForm'
import './MiPerfil.css'

const generalFields = [
  ['Régimen fiscal', 'regimenFiscal'], ['Nombre comercial', 'nombreComercial'],
  ['Razón social', 'razonSocial'], ['RFC', 'rfc'], ['CURP', 'curp'],
  ['Nombre de contacto', 'nombreContacto'], ['Teléfono', 'telefono'], ['Celular', 'celular'],
  ['Correo electrónico', 'email'], ['Calle', 'calle'], ['No. exterior', 'exterior'],
  ['No. interior', 'interior'], ['Colonia', 'colonia'], ['Código postal', 'codigoPostal'],
  ['Delegación / municipio', 'municipio'], ['Estado', 'estado'], ['País', 'pais'],
]
const commercialFields = [
  ['Vendedor asignado', 'vendedor'], ['Días de crédito', 'diasCredito'],
  ['Cascada de descuentos', 'cascadaDescuentos'], ['Descuento total', 'descuentoTotal', '%'],
  ['Condicionado 1', 'condicionado1', '%'], ['Condición 1', 'condicion1'],
  ['Condicionado 2', 'condicionado2', '%'], ['Condición 2', 'condicion2'],
]

const displayValue = (value, suffix = '') => {
  if (value === null || value === undefined || value === '') return 'No disponible'
  return `${value}${suffix}`
}

function MiPerfil() {
  const API_URL = process.env.REACT_APP_API_URL
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState(null)

  useEffect(() => {
    axios.get(`${API_URL}/mi-perfil`)
      .then(({data}) => setProfile(data.data))
      .catch((error) => setMessage({type: 'danger', text: error.response?.data?.message || 'No fue posible cargar tu perfil.'}))
      .finally(() => setLoading(false))
  }, [API_URL])

  return (
    <LoadingOverlay active={loading} spinner text='Cargando perfil...'>
      <div className='mi-perfil-page'>
        <header className='mi-perfil-header'>
          <div><h1>Mi Perfil</h1><p>Consulta tu información registrada y tus condiciones comerciales. Si deseas editar tu información personal o comercial, contacta a nuestro equipo de ventas.</p></div>
        </header>

        {message && <div className={`alert alert-${message.type}`}>{message.text}</div>}
        {profile && <>
          <section className='mi-perfil-section'>
            <h2>Información general</h2>
            <div className='mi-perfil-grid'>
              {generalFields.map(([label, field]) => <div className={`mi-perfil-field ${field === 'regimenFiscal' ? 'mi-perfil-field-wide' : ''}`} key={field}>
                <span>{label}</span><strong>{displayValue(profile.general[field])}</strong>
              </div>)}
            </div>
          </section>

          <section className='mi-perfil-section'>
            <h2>Información comercial</h2>
            <div className='mi-perfil-grid'>
              {commercialFields.map(([label, field, suffix]) => <div className='mi-perfil-field' key={field}>
                <span>{label}</span>
                <strong>{displayValue(profile.commercial[field], suffix)}</strong>
                {field === 'vendedor' && profile.commercial.vendedorEmail && (
                  <a className='mi-perfil-vendedor-email' href={`mailto:${profile.commercial.vendedorEmail}`}>{profile.commercial.vendedorEmail}</a>
                )}
              </div>)}
            </div>
          </section>
        </>}

        <section className='mi-perfil-section mi-perfil-password'>
          <div className='mi-perfil-password-title'><h2>Cambiar contraseña</h2><p>Por seguridad, confirma primero tu contraseña actual.</p></div>
          <ChangePasswordForm endpoint='mi-perfil-password' />
        </section>
      </div>
    </LoadingOverlay>
  )
}

export {MiPerfil}
